// extracted by mini-css-extract-plugin
export default {"ticket":"ticket_ticket__5KT5E","ticketMiddleSection":"ticket_ticketMiddleSection__u163A","ticketBottomSection":"ticket_ticketBottomSection__KMAth"};